import { u21CreateAsyncThunk } from 'app/shared/thunk/u21CreateAsyncThunk';
import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';

import { ActivityAnalysisState } from 'app/modules/activityAnalysis/models';
import { Filter } from 'app/modules/filters/models';

import { getLocalStorageJSON } from 'app/shared/utils/localStorage';
import { getValidFilters } from 'app/modules/filters/utils';

import { LocalStorageKeys } from 'app/shared/constants/localStorage';
import { ALL_ACTIVITY_ANALYSIS_FILTER_OPTIONS } from 'app/modules/activityAnalysis/filters';

const ACTIVITY_ANALYSIS_NAME = 'activityAnalysis';

const initialState: Readonly<ActivityAnalysisState> = {
  activityAnalysisFilters: getValidFilters(
    getLocalStorageJSON(LocalStorageKeys.ACTIVITY_ANALYSIS_FILTERS),
    ALL_ACTIVITY_ANALYSIS_FILTER_OPTIONS,
  ),
};

export const setActivityAnalysisFilters = u21CreateAsyncThunk<
  Filter[],
  Filter[]
>(`${ACTIVITY_ANALYSIS_NAME}/SET_ACTIVITY_ANALYSIS_FILTERS`, (payload) => {
  localStorage.setItem(
    LocalStorageKeys.ACTIVITY_ANALYSIS_FILTERS,
    JSON.stringify(payload),
  );
  return payload;
});

export const activityAnalysisSlice = u21CreateSlice({
  name: ACTIVITY_ANALYSIS_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setActivityAnalysisFilters.fulfilled, (draft, action) => {
      draft.activityAnalysisFilters = action.payload;
    });
  },
});

export const ACTIVITY_ANALYSIS_SLICE_NAME = activityAnalysisSlice.name;
export default activityAnalysisSlice.reducer;
